import { useEffect } from "react";
import { useState } from "react";
import { Modal, Col, Row, Form } from "react-bootstrap";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { getAllBanks } from "../../../../Helpers/apiCalls/banksAPi";
import { paymentModal } from "../../../../Helpers/apiCalls/Purchases/purchaseOrderApi";
import { paymentModalPotato } from "../../../../Helpers/apiCalls/PotatoCorner/Purchases/purchaseOrderApi";
import Select from "react-select"
import ReactLoading from "react-loading";
import {
  getTodayDateISO,
  refreshPage,
  toastStyle,
} from "../../../../Helpers/Utils/Common";
import { validatePoPayment } from "../../../../Helpers/Validation/Purchase/PurchaseOrderValidation";
import InputError from "../../../../Components/InputError/InputError";

export default function PoPaymentModal({
  id,
  show,
  onHide,
  balance,
  payee,
}) {
  const [banks, setBanks] = useState([]);
  const [isClicked, setisClicked] = useState(false);
  const [isErrorPayment, setIsErrorPayment] = useState({
    payment_type: false,
    payment_date: false,
    to_bank_id: false,
    bank_name: false,
    cheque_number: false,
    cheque_date: false,
    reference_number: false,
  });

  const [poPayment, setpoPayment] = useState({
    to_bank_id: "",
    bank_name: "",
    cheque_number: "",
    cheque_date: "",
    reference_number: "",
  });
  function handleDetailChange(e, dropdown) {
    if(dropdown) {
      setpoPayment((prev) => {
        return {
          ...prev,
          [e.name]: e.value,
          from_account_name: e.account_name,
          from_account_no: e.account_no,
        };
      });
    } else {
      const { name, value } = e.target;
      setpoPayment((prev) => {
        return {
          ...prev,
          [name]: value,
        };
      });
    }
  }

  async function handleCreatePayment() {
    if (validatePoPayment(poPayment, balance, setIsErrorPayment)) {
      setisClicked(true)
      const response = await paymentModal(
        id,
        poPayment,
        balance,
        payee
      );
      if (response.data) {
        if (response.data) {
          toast.success(response.data.message, {
            style: toastStyle(),
          });
        }
        setTimeout(() => refreshPage(), 1000);
      } else {
          response.error?.response?.data?.messages.map((data) => {
              return toast.error(data);
          })
          setTimeout(() => refreshPage(), 1000);
          setisClicked(false)
      }
    } else {
      toast.error("Please fill in all fields", { style: toastStyle() });
    }
  }

  async function fetchBanks() {
    const response = await getAllBanks()
    if (response.data) {
      var data = response.data.data
      // //
      var allBanks = data.map((bank) => {
        var info = {}
        info.name = "from_bank_id"
        info.label = bank.bank_name
        info.value = bank.id
        info.bank_id = bank.id
        info.account_name = bank.account_name
        info.account_no = bank.account_no
        return info
      })
      setBanks(allBanks)
    }
  }

  useEffect(() => {
    fetchBanks()
    setpoPayment({
      payment_date: getTodayDateISO(),
      deposit_date: getTodayDateISO(),
      payment_type: "cash",
      payee: payee,
      paid_amount: balance,

      cheque_date: "",
      cheque_number: "",
      check_number: "",
      bank_name: "",

      payment_description: "",
    });
  }, []);

  return (
    <div>
      <Modal show={show} onHide={onHide} size="lg" centered>
        <Modal.Header closeButton>
          <span className="page-title"> Add Payment</span>
        </Modal.Header>
        <Modal.Body className="return-body">
          <div>
            <Row className="mt-4 mb-2">
              <Col>
                <span className="edit-label">
                  Payment Date
                  <span className="color-red"> *</span>
                </span>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Control
                  type="date"
                  name="payment_date"
                  className="nc-modal-custom-text"
                  defaultValue={poPayment.payment_date}
                  onChange={(e) => handleDetailChange(e)}
                />
              </Col>
              <InputError
                isValid={isErrorPayment.payment_date}
                message={"Payment date is required"}
              />
            </Row>
            <Row className="mt-4 mb-2">
              <Col>
                <span className="edit-label">Payment Method</span>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Check
                  inline
                  label="Cash"
                  name="payment_type"
                  value="cash"
                  type="radio"
                  defaultChecked
                  onClick={(e) => {
                    handleDetailChange(e);
                  }}
                />
                <Form.Check
                  inline
                  label="Check"
                  name="payment_type"
                  type="radio"
                  value="check"
                  onClick={(e) => {
                    handleDetailChange(e);
                  }}
                />
                <Form.Check
                  inline
                  label="Bank"
                  name="payment_type"
                  value="bank"
                  type="radio"
                  onClick={(e) => {
                    handleDetailChange(e);
                  }}
                />
                <Form.Check
                  inline
                  label="Others"
                  name="payment_type"
                  value="others"
                  type="radio"
                  onClick={(e) => {
                    handleDetailChange(e);
                  }}
                />
              </Col>
              <InputError
                isValid={isErrorPayment.payment_type}
                message={"Payment type is required"}
              />
              <Col>
                <span className="">Balance:</span>
                <span className="edit-label"> </span>
                <span className="">{balance}</span>
              </Col>
            </Row>
          </div>

          {/* CASH PAYMENT DETAILS */}
          {poPayment.payment_type === "cash" && (
            <>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">
                    Paid Amount
                    <span className="color-red"> *</span>
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    name="paid_amount"
                    className="nc-modal-custom-text"
                    defaultValue={balance}
                    onChange={(e) => handleDetailChange(e)}
                  />
                  <InputError
                    isValid={isErrorPayment.paid_amount}
                    message={"Amount is required and should be greater than 0"}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">
                    Deposit Date
                    {/* <span className="color-red"> *</span> */}
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="date"
                    name="deposit_date"
                    className="nc-modal-custom-text"
                    defaultValue={poPayment.deposit_date}
                    onChange={(e) => handleDetailChange(e)}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">
                    Deposited to
                    {/* <span className="color-red"> *</span> */}
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    name="to_bank_name"
                    className="nc-modal-custom-text"
                    value={poPayment.to_bank_name}
                    onChange={(e) => handleDetailChange(e)}
                  />
                  <InputError
                    isValid={isErrorPayment.to_bank_name}
                    message={"Bank name is required"}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">
                    Term (days)
                    <span className="edit-optional px-2">(Optional)</span>
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    name="term_days"
                    className="nc-modal-custom-text"
                    value={poPayment.term_days}
                    onChange={(e) => handleDetailChange(e)}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">Payee</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    name="payee"
                    className="nc-modal-custom-text"
                    value={payee}
                    onChange={(e) => handleDetailChange(e)}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">
                    Remarks
                    <span className="edit-optional px-2">(Optional)</span>
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    as="textarea"
                    name="remarks"
                    value={setpoPayment.remarks}
                    className="nc-modal-custom-text"
                    onChange={(e) => handleDetailChange(e)}
                  />
                </Col>
              </Row>
            </>
          )}

          {/* CHECK PAYMENT DETAILS */}
          {poPayment.payment_type === "check" && (
            <>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">
                    Paid Amount
                    <span className="color-red"> *</span>
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    name="paid_amount"
                    className="nc-modal-custom-text"
                    defaultValue={balance}
                    onChange={(e) => handleDetailChange(e)}
                  />
                  <InputError
                    isValid={isErrorPayment.paid_amount}
                    message={"Amount is required and should be greater than 0"}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">Check Date</span>
                    <span className="color-red"> *</span>
                </Col>
                <Col>
                  <span className="edit-label">Check Number</span>
                    <span className="color-red"> *</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="date"
                    name="cheque_date"
                    className="nc-modal-custom-text"
                    defaultValue={poPayment.cheque_date}
                    onChange={(e) => handleDetailChange(e)}
                  />
                  <InputError
                    isValid={isErrorPayment.cheque_date}
                    message={"Check date is required"}
                  />
                </Col>
                <Col>
                  <Form.Control
                    type="text"
                    name="cheque_number"
                    className="nc-modal-custom-text"
                    defaultValue={poPayment.cheque_number}
                    onChange={(e) => handleDetailChange(e)}
                  />
                  <InputError
                    isValid={isErrorPayment.cheque_number}
                    message={"Cheque number is required"}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">
                    Deposit Date
                    {/* <span className="color-red"> *</span> */}
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="date"
                    name="deposit_date"
                    className="nc-modal-custom-text"
                    defaultValue={poPayment.deposit_date}
                    onChange={(e) => handleDetailChange(e)}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">
                    Deposited to
                    <span className="color-red"> *</span>
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    name="to_bank_name"
                    className="nc-modal-custom-text"
                    value={poPayment.to_bank_name}
                    onChange={(e) => handleDetailChange(e)}
                  />
                  <InputError
                    isValid={isErrorPayment.to_bank_name}
                    message={"Bank name is required"}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">Payee</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    name="payee"
                    className="nc-modal-custom-text"
                    value={payee}
                    onChange={(e) => handleDetailChange(e)}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">
                    Term (days)
                    <span className="edit-optional px-2">(Optional)</span>
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    name="term_days"
                    className="nc-modal-custom-text"
                    value={poPayment.term_days}
                    onChange={(e) => handleDetailChange(e)}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">
                    Remarks
                    <span className="edit-optional px-2">(Optional)</span>
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    as="textarea"
                    name="remarks"
                    value={poPayment.remarks}
                    className="nc-modal-custom-text"
                    onChange={(e) => handleDetailChange(e)}
                  />
                </Col>
              </Row>
            </>
          )}

          {/* OTHERS PAYMENT DETAILS */}
          {poPayment.payment_type === "others" && (
            <>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">
                    Paid Amount
                    <span className="color-red"> *</span>
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    name="paid_amount"
                    className="nc-modal-custom-text"
                    defaultValue={balance}
                    onChange={(e) => handleDetailChange(e)}
                  />
                  <InputError
                    isValid={isErrorPayment.paid_amount}
                    message={"Amount is required and should be greater than 0"}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">
                    Deposit Date
                    {/* <span className="color-red"> *</span> */}
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="date"
                    name="deposit_date"
                    className="nc-modal-custom-text"
                    defaultValue={poPayment.deposit_date}
                    onChange={(e) => handleDetailChange(e)}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">
                    Deposited to
                    {/* <span className="color-red"> *</span> */}
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    name="to_bank_name"
                    className="nc-modal-custom-text"
                    value={poPayment.to_bank_name}
                    onChange={(e) => handleDetailChange(e)}
                  />
                  <InputError
                    isValid={isErrorPayment.to_bank_name}
                    message={"Bank name is required"}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">Payee</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    name="payee"
                    className="nc-modal-custom-text"
                    value={payee}
                    onChange={(e) => handleDetailChange(e)}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                    <span className="edit-label">
                        Type
                        <label className="badge-required">{` *`}</label>
                    </span>
                </Col>
                <Col>
                  <span className="edit-label">
                    Transaction Number
                    <label className="badge-required">{` *`}</label>
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                    <Form.Control
                        type="text"
                        name="transaction_type"
                        className="nc-modal-custom-text"
                        value={
                            poPayment.transaction_type
                        }
                        onChange={(e) => handleDetailChange(e)}
                    />
                    <InputError
                        isValid={isErrorPayment.transaction_type}
                        message={"Reference number to is required"}
                    />
                </Col>
                <Col>
                  <Form.Control
                    type="text"
                    name="transaction_no"
                    className="nc-modal-custom-text"
                    value={poPayment.transaction_no}
                    onChange={(e) => handleDetailChange(e)}
                  />
                  <InputError
                    isValid={isErrorPayment.transaction_no}
                    message={"Transaction number to is required"}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">Payment Description</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    name="payment_description"
                    className="nc-modal-custom-text"
                    defaultValue={poPayment.payment_description}
                    onChange={(e) => handleDetailChange(e)}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">
                    Term (days)
                    <span className="edit-optional px-2">(Optional)</span>
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    name="term_days"
                    className="nc-modal-custom-text"
                    value={poPayment.term_days}
                    onChange={(e) => handleDetailChange(e)}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">
                    Remarks
                    <span className="edit-optional px-2">(Optional)</span>
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    as="textarea"
                    name="remarks"
                    value={poPayment.remarks}
                    className="nc-modal-custom-text"
                    onChange={(e) => handleDetailChange(e)}
                  />
                </Col>
              </Row>
            </>
          )}

          {/* BANK PAYMENT DETAILS */}
          {poPayment.payment_type === "bank" && (
            <>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">
                    Paid Amount
                    <span className="color-red"> *</span>
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    name="paid_amount"
                    className="nc-modal-custom-text"
                    defaultValue={balance}
                    onChange={(e) => handleDetailChange(e)}
                  />
                  <InputError
                    isValid={isErrorPayment.paid_amount}
                    message={"Amount is required and should be greater than 0"}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">
                    Reference Number
                    <label className="badge-required">{` *`}</label>
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    name="reference_number"
                    className="nc-modal-custom-text"
                    value={poPayment.reference_number}
                    onChange={(e) => handleDetailChange(e)}
                  />
                  <InputError
                    isValid={isErrorPayment.reference_number}
                    message={"Reference number to is required"}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">
                    To Bank
                    <span className="color-red"> *</span>
                  </span>
                </Col>
                <Col>
                  <span className="edit-label">
                    Account Name
                    <span className="color-red"> *</span>
                  </span>
                </Col>
                <Col>
                  <span className="edit-label">
                    Account No
                    <span className="color-red"> *</span>
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    name="to_bank_name"
                    className="nc-modal-custom-text"
                    value={poPayment.to_bank_name}
                    onChange={(e) => handleDetailChange(e)}
                  />
                  <InputError
                    isValid={isErrorPayment.to_bank_name}
                    message={"Bank name is required"}
                  />
                </Col>
                <Col>
                  <Form.Control
                    type="text"
                    name="to_account_name"
                    className="nc-modal-custom-text"
                    value={poPayment.to_account_name}
                    onChange={(e) => handleDetailChange(e)}
                  />
                  <InputError
                    isValid={isErrorPayment.to_account_name}
                    message={"Bank name is required"}
                  />
                </Col>
                <Col>
                  <Form.Control
                    type="text"
                    name="to_account_no"
                    className="nc-modal-custom-text"
                    value={poPayment.to_account_no}
                    onChange={(e) => handleDetailChange(e)}
                  />
                  <InputError
                    isValid={isErrorPayment.to_account_no}
                    message={"Bank name is required"}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">
                    From Bank
                    <span className="color-red"> *</span>
                  </span>
                </Col>
                <Col>
                  <span className="edit-label">
                    Account Name
                    <span className="color-red"> *</span>
                  </span>
                </Col>
                <Col>
                  <span className="edit-label">
                    Account No
                    <span className="color-red"> *</span>
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    // value={fromBankValue}
                    placeholder="Select Bank..."
                    options={banks}
                    onChange={(e) => handleDetailChange(e, true)}
                  />
                  {/* <Form.Control
                    type="text"
                    name="to_bank_name"
                    className="nc-modal-custom-text"
                    value={poPayment.to_bank_name}
                    onChange={(e) => handleDetailChange(e)}
                  /> */}
                  <InputError
                    isValid={isErrorPayment.from_bank_id}
                    message={"Bank name is required"}
                  />
                </Col>
                <Col>
                  <Form.Control
                    type="text"
                    name="from_account_name"
                    className="nc-modal-custom-text"
                    value={poPayment.from_account_name}
                    onChange={(e) => handleDetailChange(e)}
                  />
                  <InputError
                    isValid={isErrorPayment.from_account_name}
                    message={"Bank name is required"}
                  />
                </Col>
                <Col>
                  <Form.Control
                    type="text"
                    name="from_account_no"
                    className="nc-modal-custom-text"
                    value={poPayment.from_account_no}
                    onChange={(e) => handleDetailChange(e)}
                  />
                  <InputError
                    isValid={isErrorPayment.from_account_no}
                    message={"Bank name is required"}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">Payee</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    name="payee"
                    className="nc-modal-custom-text"
                    value={payee}
                    onChange={(e) => handleDetailChange(e)}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">Payment Description</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    name="payment_description"
                    className="nc-modal-custom-text"
                    defaultValue={poPayment.payment_description}
                    onChange={(e) => handleDetailChange(e)}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">
                    Term (days)
                    <span className="edit-optional px-2">(Optional)</span>
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    name="term_days"
                    className="nc-modal-custom-text"
                    value={poPayment.term_days}
                    onChange={(e) => handleDetailChange(e)}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">
                    Remarks
                    <span className="edit-optional px-2">(Optional)</span>
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    as="textarea"
                    name="remarks"
                    value={poPayment.remarks}
                    className="nc-modal-custom-text"
                    onChange={(e) => handleDetailChange(e)}
                  />
                </Col>
              </Row>
            </>
          )}
          <div className="d-flex justify-content-end pt-5 pb-3">
          <button type="button" className="button-secondary me-3" onClick={onHide}>
            Cancel
          </button>
          {isClicked ? (
              <div
                  className={"button-primary"}
              >
                  <ReactLoading
                      type="bubbles"
                      color="#FFFFFF"
                      height={50}
                      width={50}
                  />
              </div>
          ) : (
              <button
                  type="button"
                  className="button-primary"
                  onClick={() => handleCreatePayment()}
              >
                  Pay
              </button>
          )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
